import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { useQuery } from '@apollo/client'
import { useCart } from 'lib/core/hooks'
import { useCheckout } from 'lib/modules/checkout'
import { setPaymentMethod } from 'lib/core/data/quote/paymentMethod'
import { MagentoAvailablePaymentMethod as AvailablePaymentMethod } from 'lib/types'
import { getStoreConfig } from 'services/storeConfig'
import { Option } from './components/Option'
import { Options } from './styled'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'

export const PaymentOptions = () => {
  const dispatch = useDispatch()
  const { cartId, cart } = useCart()
  const { paymentMethod } = useCheckout()
  const { loading, data } = useQuery(getStoreConfig)
  const availablePaymentMethods = cart?.data?.availablePaymentMethods
  const hidePaymentMethods = data?.storeConfig?.payment_payeezy_hide_other_methods === '1'

  useEffect(() => {
    if (hidePaymentMethods && availablePaymentMethods?.find(method => method.code === PAYMENT_METHOD.PAYEEZY)) {
      if (!cartId) {
        return
      }

      dispatch(setPaymentMethod({
        cartId,
        code: PAYMENT_METHOD.PAYEEZY
      }))
    }
  }, [availablePaymentMethods, cartId, dispatch, hidePaymentMethods])

  function handleChange (method: AvailablePaymentMethod) {
    const { code } = method
    if (!cartId) {
      return
    }

    dispatch(setPaymentMethod({
      cartId,
      code
    }))
  }

  return (
    <>
      <h2>
        <FormattedMessage
          id='checkout.billing.paymentInformation'
        />
      </h2>
      {!loading && (
        <Options style={{ display: hidePaymentMethods ? 'none' : 'block' }}>
          {availablePaymentMethods?.filter(method => !method.code.includes('vault')).map(method => {
            const { title, code } = method

            if (code) {
              return (
                <Option
                  isSelected={paymentMethod.code === code}
                  key={code}
                  method={method}
                  onChange={handleChange}
                >
                  {title}
                </Option>
              )
            } else {
              return (
                <div
                  key={code}
                >
                  {title} (Not supported yet)
                </div>
              )
            }
          })}
        </Options>
      )}
    </>
  )
}
